/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const PlugIconConfig = {
  name: 'PlugIcon',
  height: 512,
  width: 384,
  svgPath: 'M256 144V32c0-17.673 14.327-32 32-32s32 14.327 32 32v112h-64zm112 16H16c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h16v32c0 77.406 54.969 141.971 128 156.796V512h64v-99.204c73.031-14.825 128-79.39 128-156.796v-32h16c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16zm-240-16V32c0-17.673-14.327-32-32-32S64 14.327 64 32v112h64z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(PlugIconConfig);
//# sourceMappingURL=plug-icon.js.map